export default {
  mediaMax: 2560,
  landscapeCutoff: 550
}